import React from "react";

const Dialog = ({ type, message, onClose }) => {
  const dialogStyles = {
    success: "bg-green-100 text-green-700 border-green-400",
    error: "bg-red-100 text-red-700 border-red-400",
  };

  const iconStyles = {
    success: (
      <svg
        className="w-6 h-6 text-green-600"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
    ),
    error: (
      <svg
        className="w-6 h-6 text-red-600"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.707 12.293a1 1 0 01-1.414 0L5 10.707a1 1 0 011.414-1.414L8 10.586l5.293-5.293a1 1 0 111.414 1.414l-6 6z"
          clipRule="evenodd"
        />
      </svg>
    ),
  };

  return (
    <div
      className={`flex items-center p-4 mb-4 border rounded-md ${dialogStyles[type]}`}
      role="alert"
    >
      <div className="flex-shrink-0">{iconStyles[type]}</div>
      <div className="ml-3">
        <p className="text-sm">{message}</p>
      </div>
      <button
        onClick={onClose}
        className="ml-auto text-sm text-gray-500 hover:text-gray-700"
        aria-label="Close"
      >
        <svg
          className="w-4 h-4"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 8.586l-4.95-4.95a1 1 0 00-1.415 1.414L8.586 10l-4.95 4.95a1 1 0 101.415 1.414L10 11.414l4.95 4.95a1 1 0 001.414-1.414L11.414 10l4.95-4.95a1 1 0 00-1.414-1.414L10 8.586z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
};

export default Dialog;
